import {parseId} from '../../helpers'
import {PolicyStatus} from '../../types/policies'
import {AllStates, NodeStateEU} from '../../types/statesEU'

export function pickObjectFields<T extends object, K extends keyof T>(
  obj: T,
  keys: readonly K[]
): Pick<T, K> {
  const result = {} as Pick<T, K>
  keys.forEach((key) => {
    if (key in obj) result[key] = obj[key]
  })
  return result
}

export const getColorByStatus = (statuses: {node: PolicyStatus}[], statusCode: string): string => {
  const found = statuses.find(({node}) => node.code === statusCode)
  return found?.node.color ?? 'orange'
}

export const getTitleByStatus = (statuses: {node: PolicyStatus}[], statusCode: string): string => {
  const found = statuses.find(({node}) => node.code === statusCode)
  return found?.node.title ?? statusCode
}

export const getStateEUByCode = (
  dataStates: AllStates | undefined,
  code: string
): NodeStateEU | undefined => {
  if (!dataStates) return undefined
  const match = dataStates.edges.find(({node}) => node.code === code)
  return match?.node
}

export const getStateEUById = (
  dataStates: AllStates | undefined,
  id: string
): NodeStateEU | undefined => {
  if (!dataStates) return undefined
  const match = dataStates.edges.find(({node}) => node.id === id)
  return match?.node
}
export const getStateEUParseIdById = (
  dataStates: AllStates | undefined,
  id: string
): NodeStateEU | undefined => {
  if (!dataStates) return undefined
  const match = dataStates.edges.find(
    ({node}) => parseId(node.id) === id || parseId(node.id) === parseId(id) || node.id === id
  )
  return match?.node
}

export function mapNodeToFormikValues<T extends Record<string, any>>(
  node: Record<string, any>,
  template: T,
  specialFields: Partial<Record<keyof T, (value: any) => any>> = {}
): T {
  const result: Partial<T> = {}

  for (const key in template) {
    const value = node[key]
    const handler = specialFields[key]

    if (handler) {
      result[key] = handler(value)
    } else if (value instanceof Date) {
      result[key] = value.toISOString().slice(0, 10) as any
    } else if (typeof value === 'object' && value !== null && 'id' in value) {
      result[key] = value.id as any
    } else {
      result[key] = value as any
    }
  }

  return {
    ...structuredClone(template),
    ...result,
  }
}
